import { render, staticRenderFns } from "./e-copy-text.vue?vue&type=template&id=6ced8ac0&scoped=true&lang=pug&"
import script from "./e-copy-text.vue?vue&type=script&lang=js&"
export * from "./e-copy-text.vue?vue&type=script&lang=js&"
import style0 from "./e-copy-text.vue?vue&type=style&index=0&id=6ced8ac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ced8ac0",
  null
  
)

export default component.exports